/**
 * One place that turns Stripe cents into the price a buyer reads.
 *
 * Three call sites were each running `Math.round(cents / 100)`, which renders a
 * $19.99 price as "$20" — a figure the card is never charged. Stripe Prices are
 * also immutable, so a city created before a price change keeps its old amount:
 * every call site formats the row's own `priceCents`, never the current
 * `CITY_REPORT_PRICE_CENTS` constant.
 *
 * USD is hardcoded because the API derives every city price from the currency
 * of `STRIPE_PRICE_STARTER` (Stripe requires one currency across a
 * subscription), and that price is USD. If a second currency is ever
 * introduced, the API must start returning it alongside the amount.
 */
export function formatReportPrice(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}
